import React from 'react';

const ActionIcon = (props: any) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="0.5" y="0.5" width="39" height="39" rx="5.5" fill="#141216" />
    <rect x="0.5" y="0.5" width="39" height="39" rx="5.5" stroke="#E5E4E7" />
    <path
      d="M20 29.4004C24.9706 29.4004 29 25.371 29 20.4004C29 15.4298 24.9706 11.4004 20 11.4004C15.0294 11.4004 11 15.4298 11 20.4004C11 25.371 15.0294 29.4004 20 29.4004Z"
      stroke="white"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M20 24.4004V25.9004" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M20 14.9004V16.4004" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M22.5 16.9004H18.75C18.2859 16.9004 17.8408 17.0848 17.5126 17.413C17.1844 17.7411 17 18.1863 17 18.6504C17 19.1145 17.1844 19.5596 17.5126 19.8878C17.8408 20.216 18.2859 20.4004 18.75 20.4004H21.25C21.7141 20.4004 22.1592 20.5848 22.4874 20.913C22.8156 21.2411 23 21.6863 23 22.1504C23 22.6145 22.8156 23.0596 22.4874 23.3878C22.1592 23.716 21.7141 23.9004 21.25 23.9004H17"
      stroke="white"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ActionIcon;
